import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '../../components/Loader/Loader';
import { setLanguageCode } from '../../utils/helpers/locale.helper';
import { useAppData } from '../../context';

import './Loading.scss';
import { Icon } from '../../components/Icon/Icon';
import { TUDOR_COLORS } from '../../utils/helpers/constants.helper';

function Loading() {
  const { cardType } = useAppData();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (cardType && cardType.toLowerCase() === 'sc') {
      setLanguageCode(i18n);
    }
  }, [cardType, i18n]);

  return (
    <div className="loading">
      <Icon
        className="basicLogo"
        name="tudor-logo"
        color={TUDOR_COLORS.WHITE}
        raw
      />
      <div className="smallTitleLight">{t('welcome')}</div>
      <div className="mediumTitle">Tudor</div>
      <div className="bigTitle">WATCH ID</div>
      <Loader />
      <div className="loading-background-overlay" />
    </div>
  );
}

export default Loading;
